import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ConfirmRegistration } from "../../engine/baseApiClient";
import { Typography } from "@mui/material";
import navigationPaths from "../../engine/navigationPaths";

function ConfirmEmail() {
    const [isConfirmed, setIsConfirmed] = React.useState(false);
    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const navigate = useNavigate();
    const token = query.get('registrationToken');
    
    React.useEffect(() => { 
        async function doRegistrationConfirmationAsync() {
            const resp = await ConfirmRegistration(token);
            if(resp.status == 'OK') {
                setIsConfirmed(true);
                navigate(navigationPaths().HomeAfterEmailConfirmation);
            };
        }
        doRegistrationConfirmationAsync();
    }, []);

    return (
        <div>
            <Typography fontSize={24} sx={{mb:1}}>Trwa weryfikacja adresu e-mail, bieżący status: {isConfirmed.toString()}.</Typography>
        </div>
    );
}

export default ConfirmEmail;
